import { useEffect, useRef } from 'react'
import { useExternalLinkIframe } from '../../state'

export const GlobalLinkInterceptor = () => {
  const { open, isOpen } = useExternalLinkIframe()
  const lastTriggerElement = useRef<HTMLAnchorElement | null>(null)

  useEffect(() => {
    const interceptLink = (link: HTMLAnchorElement, e: Event) => {
      const href = link.getAttribute('href')
      const isExternal = link.target === '_blank'

      if (isExternal && href !== null) {
        e.preventDefault()
        e.stopPropagation()
        lastTriggerElement.current = link
        open(href)
      }
    }

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const link = target.closest('a')

      if (link !== null) {
        interceptLink(link, e)
      }
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') {
        return
      }

      const target = e.target as HTMLElement
      const link = target.closest('a')

      if (link !== null) {
        interceptLink(link, e)
      }
    }

    document.addEventListener('click', handleClick, true)
    document.addEventListener('keydown', handleKeyDown, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
      document.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [open])

  useEffect(() => {
    if (!isOpen && lastTriggerElement.current) {
      lastTriggerElement.current.focus()
      lastTriggerElement.current = null
    }
  }, [isOpen])

  return null
}
